import React, {useEffect, useState} from 'react';
import {connect} from 'react-redux';
import './styles.scss';
import {compose} from 'redux';
import Header2 from '../../../../components/headers/header2';
import {Column, Row} from '../../../../components/layout';
import {
  addToGlobalStyles,
  addToWizard,
  setWizard,
} from '../../../../store/actions';
import {strings} from '../../../../util/strings';
import * as fonts from '../../../../util/fonts';
import Stepper from '../../../../components/stepper';
import {Link, useLocation} from 'react-router-dom';
import colors from '../../../../util/colors';
import {get} from '../../../../api/api';
import {
  getAppointmentSpecialities,
  getAppointmentSpecialitiesDetail,
  uriGetAppointmentsUpcoming,
} from '../../../../api/endpoints';
import Icon from '../../../../components/icon';
import {Icons} from '../../../../util/icons';
import {useMediaQuery} from 'react-responsive';
import SpecialitySelect from './speciality-select/SpecialitySelect';
import AppSpinner from '../../../../components/app-spinner';
import ScheduledAppointmentDetails from './scheduled-appointment-details/ScheduledAppointmentDetails';
import NewPatientValidation from '../../../reimbursements/reimbursement-request/steps/new-patient-validation';

export interface ScheduleAppointmentProps {
  buStyles: any;
  selectedBu: any;
  labels: typeof strings.pt.appointments;
  user: any;
  language: any;
  setWizard(value: any): void;
  addToWizard(value: any): void;
  addToGlobalStyles(value: any): void;
  wizard: any;
}

function ScheduleAppointment({
  buStyles,
  selectedBu,
  labels,
  user,
  language,
  setWizard,
  addToWizard,
  wizard,
}: ScheduleAppointmentProps) {
  const [isLoading, setIsLoading] = useState(false);

  const featureName = 'ScheduleAppointment';

  const isResponsive = useMediaQuery({maxDeviceWidth: 768});

  const location: any = useLocation();

  const getSpecialities = async () => {
    try {
      let resultToFormat: any = {};
      if (user.state === 'NOTCLIENT' || user.state === 'NOT_FOUND') {
        resultToFormat = await get(
          getAppointmentSpecialitiesDetail(),
          false,
          0,
          featureName
        );
        resultToFormat = resultToFormat?.data?.items?.filter(
          (spec: any) => spec.showToAll && spec.status === 'ACTIVE'
        );
      } else {
        resultToFormat = await get(
          getAppointmentSpecialities(selectedBu.buId, selectedBu.benNbr),
          false,
          0,
          featureName
        ).then((resp: any) => resp?.data?.items || []);
      }
      const specialityOptions = resultToFormat.map((el: any) => {
        const integratorSpecialty = el.integratorSpecialty;
        const priceCalculation = el.priceCalculation;
        const numberOfDefaultDays = el.numberOfDefaultDays;
        const sp = el.specialtyDetails.find(
          (detail: any) => detail.languageAlias === language
        );
        if (sp) {
          return {
            ...sp,
            integratorSpecialty: integratorSpecialty,
            priceCalculation: priceCalculation,
            numberOfDefaultDays: numberOfDefaultDays,
          };
        }
      });
      const patientInsurance = {
        patient: location.state.patientList[0],
        specialities: specialityOptions,
      };
      addToWizard({patientInsurance: patientInsurance, step: 1});
    } catch {
    } finally {
      setIsLoading(false);
    }
  };

  const isAbleToSchedule = async (patientSelected: any) => {
    let canProceed = false;
    try {
      await get(
        uriGetAppointmentsUpcoming(patientSelected.buId, patientSelected.memId),
        false,
        0,
        featureName
      ).then((res: any) => {
        canProceed =
          res.data?.items?.length <
          labels?.appointments_schedule_upcoming_limit_default;

        return canProceed;
      });
    } catch (err) {
      canProceed = true;
    }
    return canProceed;
  };

  useEffect(() => {
    if (location.state.patientList.length === 1) {
      setIsLoading(true);
      getSpecialities();
    }
  }, []);

  const renderCloseStepper = () => {
    return (
      <Link
        onClick={async () => {
          setWizard({});
        }}
        to="/consultas-online"
        className="reimbursement-header-content-exit-label"
        style={{
          ...fonts.SM,
          ...fonts.SemiBold,
          color: buStyles?.primaryColor || colors.blue,
        }}>
        {labels?.appointments_schedule_leave}
        <Icon
          className="reimbursement-header-content-close-icon svg-close-button inline-svg-close-button"
          name={Icons.CLOSE}
          width={'12'}
          height={'12'}
          changeViewbox={true}
          strokeWidth={'0.5'}
        />
      </Link>
    );
  };

  const renderReturnOnStepper = () => {
    return (
      <a
        onClick={async () => {
          setWizard({...wizard, step: 1});
        }}
        className="reimbursement-header-content-return-label"
        style={{
          ...fonts.SM,
          ...fonts.SemiBold,
          color: buStyles?.primaryColor || colors.blue,
        }}>
        <Icon
          className="schedule-appointment-header-return-icon"
          name={Icons.CHEVRON_LEFT}
          width={'12'}
          height={'12'}
          changeViewbox={true}
          strokeWidth={'0.5'}
        />
        {labels?.appointments_schedule_return}
      </a>
    );
  };

  const renderStepper = () => {
    return [
      {
        index: 0,
        label: labels?.appointments_schedule_step1,
        component: (onSubmit: any, nextStepHandler: any) => {
          return (
            <NewPatientValidation
              onSubmit={onSubmit}
              nextStep={nextStepHandler}
              validationMethod={isAbleToSchedule}
              functionalityAtiva={'consulta-online'}
            />
          );
        },
        onSubmit: (values: any) => addToWizard({patientInsurance: {...values}}),
      },
      {
        index: 1,
        label: labels?.appointments_schedule_step2,
        component: (onSubmit: any, nextStepHandler: any) => (
          <SpecialitySelect
            onSubmit={onSubmit}
            nextStep={nextStepHandler}
            renderClose={renderCloseStepper}
          />
        ),
        onSubmit: (values: any) => {},
      },
      {
        index: 2,
        label: labels?.appointments_schedule_step3,
        component: (onSubmit: any, nextStepHandler: any) => (
          <ScheduledAppointmentDetails
            onSubmit={onSubmit}
            editingAppointmentId={location.state.editingAppointmentId}
          />
        ),
        onSubmit: (values: any) => addToWizard({ActivateAccount: {...values}}),
      },
    ];
  };

  return (
    <>
      <Column className="reimbursement-main-column">
        <Column>
          <Column className="reimbursement-title-container">
            <Row className="schedule-appointment-header-row">
              <Header2
                className="reimbursement-header"
                style={{
                  ...fonts.XL,
                  ...fonts.Bold,
                  color: colors.black,
                }}>
                {labels?.appointments_choosePatient_header}
              </Header2>
            </Row>
            <Row className="reimbursement-subtitle-row">
              <p style={{...fonts.M, color: colors.black}}>
                {labels?.appointments_schedule_steps}
              </p>
            </Row>
          </Column>

          {isLoading ? (
            <Row className="stepper-spinner-row">
              <AppSpinner />
            </Row>
          ) : (
            <Stepper
              className="appointment-stepper"
              step={wizard.step}
              steps={renderStepper()}
            />
          )}
          {!isResponsive && wizard.step == '2' && renderReturnOnStepper()}
          {!isResponsive && renderCloseStepper()}
        </Column>
      </Column>
    </>
  );
}

const mapStateToProps = ({
  selectedBu,
  user,
  strings,
  globalStyles,
  wizard,
  language,
}: any) => ({
  user: user.value,
  selectedBu: selectedBu.value,
  buStyles: globalStyles.value,
  labels: strings.value.pt.appointments,
  wizard: wizard.value,
  language: language.value,
});

const mapDispatchToProps = (dispatch: any) => ({
  setWizard: (value: any) => dispatch(setWizard(value)),
  addToWizard: (value: any) => dispatch(addToWizard(value)),
  addToGlobalStyles: (value: any) => dispatch(addToGlobalStyles(value)),
});

export default compose(
  connect(mapStateToProps, mapDispatchToProps)(ScheduleAppointment)
);
